import { render, staticRenderFns } from "./InboxThreads.vue?vue&type=template&id=1102c38e&scoped=true&"
import script from "./InboxThreads.vue?vue&type=script&lang=js&"
export * from "./InboxThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1102c38e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1102c38e')) {
      api.createRecord('1102c38e', component.options)
    } else {
      api.reload('1102c38e', component.options)
    }
    module.hot.accept("./InboxThreads.vue?vue&type=template&id=1102c38e&scoped=true&", function () {
      api.rerender('1102c38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/InboxThreads.vue"
export default component.exports